// Impostazioni a schede, sul modello di SurgeAI (tela, artboard 47; spec 0.1.28): una riga di
// schede, sotto una sola card con la scheda scelta. L'indirizzo ricorda la scheda (?tab=).
export interface SettingsTab {
  id: string;
  label: string;
}

export const SETTINGS_TABS: SettingsTab[] = [
  { id: 'general', label: 'Generale' },
  { id: 'limits', label: 'Limiti dei modelli' },
  { id: 'profiles', label: 'Profili' },
  { id: 'sessions', label: 'Sessioni' },
  { id: 'updates', label: 'Aggiornamenti' },
  { id: 'notifications', label: 'Notifiche' },
  { id: 'support', label: 'Segnalazioni' },
  { id: 'backup', label: 'Backup' },
  { id: 'help', label: 'Aiuto' },
];
